var _clipPath, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTuriTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 39.356,
    viewBox: "0 0 127.033 39.356",
    width: 127.033,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h127.033v39.356h-127.033z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.427 14.862h-4v12.738h-3.561v-12.738h-4v-3.592h11.561z",
    fill: "#313131",
    transform: "translate(5.718 1.903)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#313131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.991 22.327v-11.057h3.558v10.73c0 1.235.556 2.286 2.448 2.286s2.445-1.049 2.445-2.286v-10.73h3.558v11.057c0 3.5-2.58 5.6-6 5.6s-6.006-2.1-6.006-5.6",
    transform: "translate(7.597 1.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.7 22.235h-1.69v5.365h-3.559v-16.33h6.228a5.5 5.5 0 0 1 2.468 10.33l3.314 6h-3.825zm-1.69-3.267h2.668a1.943 1.943 0 0 0 1.78-2.1 1.943 1.943 0 0 0 -1.78-2.1h-2.668z",
    transform: "translate(9.701 1.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h3.558v16.33h-3.558z",
    transform: "translate(80.826 13.172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.09 14.862h-4v12.738h-3.561v-12.738h-4v-3.592h11.561z",
    transform: "translate(12.415 1.903)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.417 19.482a8.1 8.1 0 1 1 16.19 0 8.1 8.1 0 1 1 -16.19 0m12.633 0a4.547 4.547 0 1 0 -9.074 0 4.547 4.547 0 1 0 9.074 0",
    transform: "translate(14.085 1.855)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.32 16.869a5.48 5.48 0 0 1 -5.449 5.6h-2.335v5.131h-3.557v-16.33h5.892a5.48 5.48 0 0 1 5.449 5.6m-3.559 0a1.956 1.956 0 0 0 -1.89-2.1h-2.335v4.2h2.335a1.956 1.956 0 0 0 1.89-2.1",
    transform: "translate(16.713 1.902)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.224 13.119 13.119-13.119v13.119z",
    fill: "#f9da10",
    transform: "translate(1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.343 0-13.119 13.119v-13.119z",
    fill: "#f1891e",
    transform: "translate(1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 13.119 13.119-13.119v13.119z",
    fill: "#e52d33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.566 0-13.119 13.119v-13.119z",
    fill: "#9fc425",
    transform: "translate(3.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.224 24.343 13.119-13.119v13.119z",
    fill: "#36b7bb",
    transform: "translate(1.895 1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.343 11.224-13.119 13.119v-13.119z",
    fill: "#30ab66",
    transform: "translate(1.895 1.895)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.343 22.448-13.119 13.119v-13.119z",
    fill: "#2e68b0",
    transform: "translate(1.895 3.79)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTuriTop);
export default __webpack_public_path__ + "static/media/Logo_TuriTop.5073dfecdbd2b7981e0bdec702fc03b3.svg";
export { ForwardRef as ReactComponent };